// Copyright (c) 2017 Deere & Company

import DealerInvoiceList from '../state/dealer-invoice-list';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const setDealerInvoiceList = (state, action) =>
    DealerInvoiceList.update(state, {
        $set: action.data
    });

const updateDealerInvoiceList = (state, action) =>
    DealerInvoiceList.update(state, {
        $splice: [
            [action.index, 1, action.invoice]
        ]
    });

const deleteDealerInvoiceItem = (state, action) =>
    DealerInvoiceList.update(state, {
        $splice: [
            [action.index, 1]
        ]
    });

const actionTypes = {
    [actions.DELETE_DEALER_INVOICE_ITEM]: deleteDealerInvoiceItem,
    [actions.SET_DEALER_INVOICE_LIST]: setDealerInvoiceList,
    [actions.UPDATE_DEALER_INVOICE_ITEM]: updateDealerInvoiceList,
    [actions.UPDATE_DEALER_INVOICE_PROPERTY]: updateDealerInvoiceList
};

export default (state = getDefaultState().dealerInvoices, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/reducers/dealer-invoices.js